import React from "react";
import * as styles from "./base.scss";
const ProductOrdinal = ({ passedUpdateOrdinal, passedOrdinal, selectElement, rowIndex, disabled, }) => {
    return (React.createElement("div", { className: styles.wrap },
        React.createElement("input", { className: styles.ordinal, name: rowIndex + "_ordinal", type: "text", max: "999", onChange: (e) => passedUpdateOrdinal(rowIndex, parseInt(e.target.value.replace(/[^0-9]+/g, ""))), value: passedOrdinal > 0 ? passedOrdinal.toString() : "", disabled: disabled, onFocus: () => selectElement(rowIndex, "ordinal") })));
};
export default ProductOrdinal;
